import Vue, { defineComponent, onMounted, reactive, watch, nextTick, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import DefaultLayout from '@/layouts/default'
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import enUS from 'ant-design-vue/es/locale/en_US';
import UserManager from '@/user/UserManager'
import { ssoAnthConfig } from '@/config/app-config'
import Loading from '@/view/Loading'

import './App.less'

export default defineComponent({
  name: 'App',
  setup() {
    const route = useRoute()
    const store = useStore()

    const state = reactive({
      isGettingAuth: true
    })

    const checkStaff = () => {
      state.isGettingAuth = true
      UserManager.manager.getUser().then(res => {
        if(!res) {
          UserManager.Login()
        } else {
          state.isGettingAuth = false
        }
      })
    }

    onBeforeMount(() => {
      if(location.href.indexOf('a-v2.didaadmin.com') > -1) {
        const newHref = location.href.replace('a-v2.didaadmin.com', 'a.didaadmin.com')
        window.location.href = newHref
      }
    })

    onMounted(() => {
 
      // watch(
      //   () => route.path,
      //   () => {
      //     if (
      //       route.path !== ssoAnthConfig.redirect_uri &&  // sso登录跳转过来不需要再鉴权了
      //       route.meta.requireAuth !== false &&  // route config 里面配置哪些需要鉴权 
      //       !store.state.useInfo  // a页面已经鉴权了有了userInfo，b页面就不需要了
      //     ) {
      //       checkStaff()
      //     } else {
      //       state.isGettingAuth = false
      //     }
      //   }
      // )
    })
    return () => (
      <a-config-provider locale={enUS}>
        {
          store.state.globalLoading ?
          <Loading/> :
          <DefaultLayout />
        }
      </a-config-provider>
    );
  },
});
